export const Endpoints = {
  SIGNIN: '/auth/signin',
  SIGNUP: '/auth/signup',
  AUTH: '/auth',
  COMPLETIONS: '/completions',
  OAUTH: '/auth/oauth',
  TOKENS: '/auth/tokens',
  GOOGLE_AUTH: '/auth/google',
  CONVERSATIONS: '/conversations',
  TEMPLATES: '/templates',
  TAGS: '/tags',
  USERS: '/users',
  INVOICES: '/invoices',
  STRIPE: '/stripe',
  STRIPE_SETUP: '/stripe/setup',
  STRIPE_PAYMENT: '/stripe/payment',
  CHAT: '/chat',
  AUDIO: '/asr',
  ADMIN: '/admin',
  CONTACT: '/contact',
  NEWSLETTER: '/newsletter',
} as const
